// The drawing box the Blockaid strip (OnchainMonitoring) and the STRIDE strip
// (ControlInspection) share. They sit side by side from lg, each at its
// column's full width, so one box means one scale and one rendered height at
// every width.

// 352 units wide: at lg a column is 462 to 488px (half of max-w-5xl less the
// gap), which draws a unit at about 1.31 to 1.39px, the 1.37px a unit had when
// the strips were drawn at a fixed 48rem. Narrowing the drawing rather than
// scaling a wider one down is what keeps the strips at that height.
export const STRIP_VIEWBOX_WIDTH = 352;

// Both drawings run their top rail 12 units down, their track at 36 and their
// bottom rail at 60. STRIDE's frame brackets reach 32 either side of the track,
// so the box ends past them at 69; Blockaid's scan region ends at 68 and takes
// the extra unit as clearance so the two boxes match.
export const STRIP_VIEWBOX_HEIGHT = 69;
export const STRIP_RAIL_TOP = 12;

// The standing "Illustration" label stands over the strip's right end and ends
// 0.25rem (gap-1) above the top rail. Its fine-print line box is 1.25rem from
// md (1rem below), so with the gap the rail falls 1.5rem under the figure's
// top. The strip's own first 12 units cover part of that, and LABEL_ROOM, a
// margin above the strip, is the rest at every width. A percentage margin
// resolves against the figure's width, which is the strip's width, hence the
// rail's share of it.
export const LABEL_ROOM = `calc(1.5rem - 100% * ${STRIP_RAIL_TOP / STRIP_VIEWBOX_WIDTH})`;
// The label is placed by its bottom edge, 1.25rem under the figure's top, so it
// ends 0.25rem above the rail whichever line box it has; below md the smaller
// one leaves 0.25rem free above it.
export const LABEL_BOTTOM = "calc(100% - 1.25rem)";
